module.exports = __webpack_public_path__ + "media/images/icons/material/facebook-caf3844a34b65ac3a5a8f5f3afc30c16.svg";